// extracted by mini-css-extract-plugin
module.exports = {"Link":"Link-module--Link--24MGY","secondaryFont":"Link-module--secondaryFont--2-v9s","unstyled":"Link-module--unstyled--3dbB0","animated":"Link-module--animated--EsPh1"};